/** The column the projects are filtered by access level, which is also its query param in the URL */
export const PROJECTS_ACCESS_LEVEL_FILTER_COLUMN = "accessLevel";

/** The column the projects are filtered by creation date, which is also its query param in the URL */
export const PROJECTS_CREATED_FILTER_COLUMN = "created";

/** The column the projects are filtered by last capture date, which is also its query param in the URL */
export const PROJECTS_LAST_CAPTURED_FILTER_COLUMN = "lastCaptured";

/** The column the projects are filtered by last update date, which is also its query param in the URL */
export const PROJECTS_LAST_UPDATED_FILTER_COLUMN = "lastUpdated";

/** The column the projects are filtered by size, which is also its query param in the URL */
export const PROJECTS_SIZE_FILTER_COLUMN = "size";

/** The column the projects are filtered by location, which is also its query param in the URL */
export const PROJECTS_LOCATION_FILTER_COLUMN = "location";

/** The label of the chip to filter the projects by location, which is no column of the table */
export const PROJECTS_LOCATION_FILTER_LABEL = "Location";

/** The column the projects are filtered by tags, which is also its query param in the URL */
export const PROJECTS_TAGS_FILTER_COLUMN = "tags";

/** The column the projects are filtered by group, which is also its query param in the URL */
export const PROJECTS_GROUP_FILTER_COLUMN = "group";

/** The columns the projects are filtered by a date, in the order of their chips */
export const PROJECTS_DATE_FILTER_COLUMNS = [PROJECTS_CREATED_FILTER_COLUMN, PROJECTS_LAST_CAPTURED_FILTER_COLUMN, PROJECTS_LAST_UPDATED_FILTER_COLUMN];

/** The columns the projects can be filtered by, in the order of their chips */
export const PROJECTS_FILTER_COLUMNS = [PROJECTS_ACCESS_LEVEL_FILTER_COLUMN, ...PROJECTS_DATE_FILTER_COLUMNS, PROJECTS_SIZE_FILTER_COLUMN, PROJECTS_LOCATION_FILTER_COLUMN, PROJECTS_TAGS_FILTER_COLUMN, PROJECTS_GROUP_FILTER_COLUMN];

/** The columns whose chips apply only one filter at a time */
export const PROJECTS_SINGLE_FILTER_COLUMNS = [...PROJECTS_DATE_FILTER_COLUMNS, PROJECTS_SIZE_FILTER_COLUMN];

/** A column the projects can be filtered by */

/** A column the projects are filtered by a date */